export function searchCodeByName(code: string, countriesCode: any) {
  if (code && code.length === 2) {
    for (const item in countriesCode) {
      if (countriesCode[item].indexOf(code) !== -1) {
        return item
      }
    }
  }
  return ''
}
